import { computed, ref } from 'vue'

const useTariffsMap = selectedCity => {
  const citiesWithTariffsMap = ['spb', 'msk', 'ekb']
  const detailsShow = ref(selectedCity.value?.alias || null)

  const cityHasTariffsZonesMap = computed(() =>
    citiesWithTariffsMap.includes(selectedCity.value?.alias)
  )

  const iFrameCode = computed(
    () =>
      `<iframe width="600px" height="600px" frameborder="0" src="${window.location.origin}/tariff_delivery_zone_map/${detailsShow.value}"></iframe>`
  )

  const detailsHandler = alias => {
    if (detailsShow.value === alias) detailsShow.value = null
    else detailsShow.value = alias
  }

  return {
    detailsShow,
    citiesWithTariffsMap,
    iFrameCode,
    cityHasTariffsZonesMap,
    detailsHandler,
  }
}

export default useTariffsMap
